/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  FlexContainer,
  IconContainer,
  Title
} from '../../../globalStyles';
import { apiEndPoints } from '../../../services/axios/endPoints';
import { WebService } from '../../../services/axios/webServices';
import { Modal } from '../../Common/PopUpModal/Modal.style';
import TabsTable from '../../Common/Tabs_Table';
import { TableContainer } from '../../Common/Tabs_Table/TabsTable.style';
import { Bttn } from '../CreateWorkOrder/AssetSelection/AssetSelection.style';
import { Creators as UpsertWorkOrderCreators } from '../CreateWorkOrder/store';
import {
  AddButton,
  CountSpan,
  DetailLabel,
  DetailText,
  EnlargedImage,
  HeaderText,
  ModalListHeader,
  PartDetailsContainer,
  PartHeader,
  PartImage,
  PartName,
  PartsContainer
} from './WorkOrderDetails.style';
import Loader from '../../Common/Loader/Loader';
import { TabsContainer } from '../../Common/Tabs/Tabs.styles';
import WoSelectedAsset from './WoSelectedAsset';
import { useActions } from '../../../store/hooks/useActions';
import { sagaCatchBlockHandling } from '../../../store/utility/sagaErrorHandling';
import Toast from '../../Common/Toast';
import PopUpModal from '../../Common/PopUpModal/Modal.view';
import DynamicSVGIcon from '../../Common/DynamicSVGIcon';
import { CancelBlack } from '../../../assets/icons';
import { getStringLocale } from '../../../constants/language';
import PaginationWithPage from '../../Common/Pagination/PaginationWithPage.view';
import { FilterBtn } from '../../../views/WorkOrders/WorkOrders.styles';
import FilterMobileIcon from '../../../assets/icons/Filter/Filters white.svg';
import { isEmpty } from '../../../shared/utility/isEmpty';
import WOFilter from '../WoFilters/WOFilter';

const WoListModal = ({ setAssetListModal, loading }) => {
  const { assetShortlist, assetListMeta, assetListData, assetSearchQueries } =
    useSelector((state) => state.upsertWorkOrder);
  const { workOrderId } = useSelector((state) => state.workOrders);
  const { filtersPayload } = useSelector((state) => state.filterData);
  const [showShortListData, setShowShortListData] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState('');

  const pageSize = 10;

  const dispatch = useDispatch();
  const { getModalAssetsSuccess } = useActions();

  const handlePageChange = async (currentPage, rest) => {
    const { searchParams } = rest || {};

    setLoader(true);
    const fullUrl = `${apiEndPoints.GetJobSpares}`;
    const page = currentPage;
    const pageSize = 10;
    const initialPayload = { type: 'AddParts' };

    try {
      const res = await WebService.post(
        `${fullUrl}${workOrderId}/${page}/${pageSize}`,
        {
          SearchFilters: { ...initialPayload, ...searchParams }
        }
      );

      if (res.status === 200) {
        const { meta, data } = res.data;
        dispatch(
          UpsertWorkOrderCreators.getAssetListSuccess({
            assetListMeta: meta,
            assetListData: data
          })
        );
        setLoader(false);
      } else {
        throw res;
      }
    } catch (err) {
      console.log(err, 'error');
      const payload = sagaCatchBlockHandling(err);
      setError(payload?.error);
    } finally {
      setLoader(false);
    }
  };

  const isMounted = useRef(false);
  useEffect(() => {
    if (isMounted.current) handlePageChange(1);
    else {
      isMounted.current = true;
    }
  }, [filtersPayload]);

  const handleShortList = (entry) => {
    const check = assetShortlist.some(
      (ele) =>
        ele.mainPartNumber === entry.mainPartNumber &&
        ele.inventPartnumber === entry.inventPartnumber &&
        ele.qtyAvailable === entry.qtyAvailable
    );
    if (!check) {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist([...assetShortlist, entry])
      );
    } else {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist(
          assetShortlist.filter(
            (ele) =>
              !(
                ele.mainPartNumber === entry.mainPartNumber &&
                ele.inventPartnumber === entry.inventPartnumber
              )
          )
        )
      );
    }
  };
  const setAssetSearchQueries = (searchQueries) => {
    dispatch(UpsertWorkOrderCreators.setAssetSearchQueries(searchQueries));
  };
  const resetSearchQueries = () => {
    dispatch(UpsertWorkOrderCreators.resetAssetSearchQueries());
  };

  const handleCancel = () => {
    setAssetListModal(false);
    dispatch(UpsertWorkOrderCreators.setAssetShortlist([]));
  };

  const handleConfirm = () => {
    setShowShortListData(true);
  };

  const backHandler = () => {
    setShowShortListData(false);
  };

  useEffect(() => {
    dispatch(UpsertWorkOrderCreators.resetAssetShortlist());
  }, []);

  const [filters, setFilters] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    if (!isEmpty(assetListMeta)) {
      const filtered = assetListMeta?.columns.filter(
        (item) =>
          // item.searchable === true ||
          Array.isArray(item.options) && item.options.length > 0
      );
      const searchable = assetListMeta?.columns?.filter(
        (item) =>
          item.searchable === true &&
          Array.isArray(item.options) &&
          !item.options.length > 0 &&
          item?.type !== 'DateTime'
      );
      setFilters({ filtered, searchable });
    }
  }, [assetListMeta]);

  const handleFilterClick = () => {
    setShowFilters(true);
  };

  const [enlargeImage, setEnlargeImage] = useState({});

  return (
    <>
      <PopUpModal
        closeModalHandler={() => null}
        width={window.innerWidth >= 768 && '80%'}
        style={{
          height: '100%',
          backgroundColor: '#FFFFFF',
          position: 'relative'
        }}
      >
        {!showShortListData && (
          <FilterBtn
            style={{ top: '0.5rem', right: '1rem' }}
            className='flex ai_center'
            onClick={handleFilterClick}
          >
            <DynamicSVGIcon iconUrl={FilterMobileIcon} width='20px' />
          </FilterBtn>
        )}
        {showFilters && (
          <WOFilter
            onCancel={() => setShowFilters(false)}
            filters={filters}
            workOrders={assetListData}
            handlePageChange={handlePageChange}
            setSearchQueries={setAssetSearchQueries}
          />
        )}
        {/* TODO: repeated styles to match child */}
        <FlexContainer
          className='jc_spacebetween ai_center'
          style={{ width: '97%', margin: '0px auto' }}
        >
          {/* <div>
            <Title className='block'>Add Parts</Title>
          </div> */}
          {/* <IconContainer onClick={handleCancel}>
            <DynamicSVGIcon iconUrl={CancelBlack} />
          </IconContainer> */}
        </FlexContainer>

        {showShortListData ? (
          <WoSelectedAsset
            backHandler={backHandler}
            setAssetListModal={setAssetListModal}
          />
        ) : (
          <>
            {loading ? (
              <Loader />
            ) : (
              <div
                style={{
                  height: 'calc(100% - 12rem)',
                  overflow: 'auto',
                  padding: '1rem'
                }}
              >
                {assetListData?.map((asset) => {
                  const assetInList = assetShortlist.some(
                    (ele) =>
                      ele.mainPartNumber === asset.mainPartNumber &&
                      ele.inventPartnumber === asset.inventPartnumber &&
                      ele.qtyAvailable === asset.qtyAvailable
                  );
                  return (
                    <>
                      <PartsContainer>
                        <PartHeader>
                          <PartImage
                            src={asset?.unfurlImageUrl}
                            width='120px'
                            height='150px'
                            onClick={() => {
                              setEnlargeImage({ display: true, asset });
                            }}
                          />
                          <PartName>{asset?.partName}</PartName>
                        </PartHeader>
                        <PartDetailsContainer>
                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('Main Part', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${
                              asset?.mainPartNumber || '-'
                            }`}</DetailText>
                          </FlexContainer>
                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('Invent Part', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${
                              asset?.inventPartNumber || '-'
                            }`}</DetailText>
                          </FlexContainer>
                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('Location', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${
                              asset?.location || '-'
                            }`}</DetailText>
                          </FlexContainer>
                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('Equipment Type', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${
                              asset?.equipmenttype || '-'
                            }`}</DetailText>
                          </FlexContainer>

                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('In Lab', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${
                              asset?.inLab || '-'
                            }`}</DetailText>
                          </FlexContainer>
                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('Qty Available', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${
                              asset?.qtyAvailable || '-'
                            }`}</DetailText>
                          </FlexContainer>
                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('Price', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${
                              asset?.BlendedCost || '-'
                            }`}</DetailText>
                          </FlexContainer>
                          <FlexContainer className='ai_center'>
                            <DetailLabel>
                              {getStringLocale('Old P/N', 'en')}
                            </DetailLabel>
                            <DetailText>{`: ${asset?.old || '-'}`}</DetailText>
                          </FlexContainer>
                        </PartDetailsContainer>
                        <Button
                          style={{
                            borderRadius: '10px',
                            width: '100%',
                            margin: '2rem 0 0 0',
                            padding: '1rem'
                          }}
                          onClick={() => {
                            handleShortList(asset);
                          }}
                          className={assetInList && 'remove'}
                          dark={true}
                        >
                          {assetInList
                            ? getStringLocale('Remove', 'en')
                            : getStringLocale('Add', 'en')}
                        </Button>
                      </PartsContainer>
                    </>
                  );
                })}
              </div>
            )}

            <div
              style={{
                width: '90vw',
                overflow: 'auto',
                padding: '1rem'
              }}
            >
              <PaginationWithPage
                ItemsPerPage={pageSize}
                total={assetListMeta?.count}
                handlePageChange={handlePageChange}
                searchParams={assetSearchQueries}
                isLoading={loading}
              />
            </div>

            {!loading && (
              <FlexContainer
                className='jc_center ac_center'
                style={{ gap: '2rem', padding: '1rem' }}
              >
                <Bttn dark onClick={handleCancel}>
                  {getStringLocale('Cancel', 'en')}
                </Bttn>
                <Bttn
                  dark
                  onClick={handleConfirm}
                  disabled={assetShortlist?.length < 1}
                >
                  {getStringLocale('Next', 'en')}
                  <CountSpan>{` ${assetShortlist.length}`}</CountSpan>
                </Bttn>
              </FlexContainer>
            )}
          </>
        )}
      </PopUpModal>
      {error && (
        <Toast
          message={error}
          header='Error'
          style={{ right: 30, zIndex: 20 }}
          fn={() => setError('')}
        />
      )}
      {enlargeImage?.display && (
        <PopUpModal
          closeModalHandler={() => {
            setEnlargeImage({});
          }}
          style={{ height: '60%' }}
        >
          <FlexContainer
            className='ai_center jc_spacebetween'
            style={{ marginBottom: '2rem' }}
          >
            <HeaderText>
              {getStringLocale(
                `${enlargeImage?.asset?.inventPartNumber}`,
                'en'
              )}
            </HeaderText>
            <div
              style={{ textAlign: 'end' }}
              onClick={() => {
                setEnlargeImage({});
              }}
            >
              <DynamicSVGIcon iconUrl={CancelBlack} width='1.5rem' />
            </div>
          </FlexContainer>

          <div style={{ height: '90%' }}>
            <EnlargedImage
              src={enlargeImage?.asset?.unfurlImageUrl}
              alt='part'
            />
          </div>
        </PopUpModal>
      )}
    </>
  );
};

export default WoListModal;
